'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSyncedCarousel = exports.initCarousel = undefined;
exports.default = initCarousels;

require('jquery');

require('slick-browserify-js');

/**
 * In order to be able to track the status of `arrows` and `dots` properties
 * and style the carousel accordingly, this methods positions data-attributes
 * on which we can rely on to write the appropriate CSS rules.
 * @param  {Objec} $slick jQuery representation of the slick carousel.
 * @param  {Object} slick the slick carousel.
 */
var _trackControlsState = function _trackControlsState($slick, slick) {

  $slick.attr('data-has-arrows', slick.options.arrows);
  $slick.attr('data-has-dots', slick.options.dots);
};

/**
 * Init a single carousel.
 * @param  {Object} $carousel The carousel.
 */
var initCarousel = exports.initCarousel = function initCarousel($carousel) {

  var carouselOptions = $carousel.attr('data-slick');

  carouselOptions = JSON && carouselOptions ? JSON.parse(carouselOptions) : undefined;

  if (carouselOptions === undefined) {

    // Force slick config to use dots if no config provided.
    $carousel.slick({ arrows: false, dots: true });
  } else {

    // Carousel that should autoplay and stop after a number of loops.
    if (carouselOptions && carouselOptions.hasOwnProperty('maxLoops')) {

      // Default settings in case it is not set into the data-slick data attribute.
      carouselOptions.arrows = carouselOptions.arrows || false;
      carouselOptions.dots = carouselOptions.dots || true;
      carouselOptions.autoplay = carouselOptions.autoplay || true;
      carouselOptions.infinite = carouselOptions.infinite || true;
      carouselOptions.autoplaySpeed = carouselOptions.autoplaySpeed || 4000;
      carouselOptions.fade = carouselOptions.fade || true;
      carouselOptions.focusOnSelect = carouselOptions.focusOnSelect || false;

      $carousel.on('init', function (event, slick) {

        // This extends the carousel to allow autoplay but with a max loop
        // option meaning the autoplay stops after a certain amount of loops.
        if (slick.options.maxLoops !== undefined) {

          // Allows to track when we can stop the autoplay.
          slick.changeCount = 0;
          slick.maxChanges = slick.slideCount * slick.options.maxLoops;
        }
      });

      // On this event we test whether or not we should stop the autoplay.
      $carousel.on('afterChange', function (event, slick, direction) {
        if (slick.changeCount !== undefined && slick.maxChanges !== undefined) {
          slick.changeCount++;
          if (slick.changeCount === slick.maxChanges - 1) {
            $carousel.slick('slickPause');
            // This is important, otherwise if the user interact again with
            // the carousel controls, the autoplay restarts. So we
            // explicitly disable it.
            $carousel.slick('slickSetOption', 'autoplay', false);
          }
        }
      });
    }

    // Inits the carousel.
    $carousel.slick(carouselOptions);
  }
};

/**
 * Enables the carousels.
 */
function initCarousels() {

  var $carousels = $('.carousel');

  if ($carousels.length > 0) {

    // Allows us to style the carousel controls properly.
    $('.carousel').on('init', function (event, slick) {
      _trackControlsState($(this), slick);
    });
    $('.carousel').on('breakpoint', function (event, slick) {
      _trackControlsState($(this), slick);
    });

    $('.carousel').each(function (index, item) {

      initCarousel($(this));
    });
  }
}

/**
 * Init synced carousels.
 *
 * A synced carousel consists of a display and a navigation.
 *
 * Example: The navigation could contain some photos, and the display could
 * have more information based on this photo. The carousels will stay in sync
 * purely based on the order of the items in the carousel.
 *
 * 1. Get the display and nav classes, and prepend a period to it. These
 * 		classes will be used in the slick configuration to tell it which navs
 * 		to sync.
 * 2. Set the carousel display 'asNavFor' attribute to the class of the
 * 		navigation.
 * 3. Set the carousel navigation 'asNavFor' attribute to the class of the
 * 		display.
 *
 * @param  {Object} $carouselDisplay The carousel display.
 * @param  {Object} $carouselNav     The carousel navigation.
 */
var initSyncedCarousel = exports.initSyncedCarousel = function initSyncedCarousel($carouselDisplay, $carouselNav) {

  var navClass = '.' + $carouselNav.attr('class'),
      /* [1] */
  displayClass = '.' + $carouselDisplay.attr('class'); /* [1] */

  $carouselDisplay.slick({
    asNavFor: navClass /* [2] */
  });

  $carouselNav.slick({
    asNavFor: displayClass /* [3] */
  });
};